// import React, { useState } from 'react';
// // ✅ CORRECT (matches the filename exactly)
// import { createAdmin } from '../../services/adminService';
// import { useAuth } from '../../context/AuthContext';
// import './CreateAdmin.css'; // Optional: include CSS

// const CreateAdmin = () => {
//   const { currentUser } = useAuth();

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     password: '',
//     permissions: {
//       manageVendors: false,
//       manageBanners: false,
//       manageReports: false,
//       manageOrders: false,
//     }
//   });

//   const [message, setMessage] = useState('');

//   // ✅ Only Super Admin can access this page
//   if (!currentUser?.isSuperAdmin) {
//     return <div className="message error">❌ Unauthorized: Only Super Admin can access this page.</div>;
//   }

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name.startsWith('permissions.')) {
//       const permKey = name.split('.')[1];
//       setFormData((prev) => ({
//         ...prev,
//         permissions: {
//           ...prev.permissions,
//           [permKey]: checked,
//         }
//       }));
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: value
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await createAdmin(formData);
//       setMessage('✅ Admin created successfully.');
//       setFormData({
//         name: '',
//         email: '',
//         password: '',
//         permissions: {
//           manageVendors: false,
//           manageBanners: false,
//           manageReports: false,
//           manageOrders: false,
//         }
//       });
//     } catch (error) {
//       console.error(error);
//       const errMsg = error.response?.data?.message || 'Server error';
//       setMessage(`❌ Failed to create admin: ${errMsg}`);
//     }
//   };

//   return (
//     <div className="form-container">
//       <h2>Create New Admin</h2>
//       {message && <div className="message">{message}</div>}
//       <form onSubmit={handleSubmit} className="admin-form">
//         <input
//           name="name"
//           value={formData.name}
//           onChange={handleChange}
//           placeholder="Name"
//           required
//         />
//         <input
//           name="email"
//           type="email"
//           value={formData.email}
//           onChange={handleChange}
//           placeholder="Email"
//           required
//         />
//         <input
//           name="password"
//           type="password"
//           value={formData.password}
//           onChange={handleChange}
//           placeholder="Password"
//           required
//         />

//         <h4>Permissions:</h4>
//         <div className="checkbox-group">
//           {Object.entries(formData.permissions).map(([key, value]) => (
//             <label key={key}>
//               <input
//                 type="checkbox"
//                 name={`permissions.${key}`}
//                 checked={value}
//                 onChange={handleChange}
//               />
//               {key.replace(/manage/, 'Manage ').replace(/([A-Z])/g, ' $1').trim()}
//             </label>
//           ))}
//         </div>

//         <button type="submit" className="submit-btn">Create Admin</button>
//       </form>
//     </div>
//   );
// };

// export default CreateAdmin;


// import React, { useState, useEffect } from 'react';
// import { createAdmin, getAdmins, updateAdmin } from '../../services/adminService';
// import { useAuth } from '../../context/AuthContext';
// import './CreateAdmin.css';

// const CreateAdmin = () => {
//   const { currentUser } = useAuth();

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     password: '',
//   });

//   const [admins, setAdmins] = useState([]);
//   const [message, setMessage] = useState('');
//   const [editMode, setEditMode] = useState(false);
//   const [editingAdminId, setEditingAdminId] = useState(null);

//   useEffect(() => {
//     fetchAdmins();
//   }, []);

//   const fetchAdmins = async () => {
//     try {
//       const data = await getAdmins();
//       setAdmins(data);
//     } catch (error) {
//       console.error('Error fetching admins:', error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (editMode) {
//         await updateAdmin(editingAdminId, {
//           name: formData.name,
//           email: formData.email,
//         });
//         setMessage('✅ Admin updated successfully.');
//       } else {
//         await createAdmin(formData);
//         setMessage('✅ Admin created successfully.');
//       }

//       setFormData({ name: '', email: '', password: '' });
//       setEditMode(false);
//       setEditingAdminId(null);
//       fetchAdmins();
//     } catch (error) {
//       console.error(error);
//       const errMsg = error.response?.data?.message || 'Server error';
//       setMessage(`❌ Operation failed: ${errMsg}`);
//     }
//   };

//   const handleEdit = (admin) => {
//     setFormData({
//       name: admin.name,
//       email: admin.email,
//       password: '',
//     });
//     setEditMode(true);
//     setEditingAdminId(admin._id);
//   };

//   const cancelEdit = () => {
//     setEditMode(false);
//     setEditingAdminId(null);
//     setFormData({ name: '', email: '', password: '' });
//   };

//   if (!currentUser?.isSuperAdmin) {
//     return <div className="message error">❌ Unauthorized: Only Super Admin can access this page.</div>;
//   }

//   return (
//     <div className="form-container">
//       <h2>{editMode ? 'Update Admin' : 'Create New Admin'}</h2>
//       {message && <div className="message">{message}</div>}

//       <form onSubmit={handleSubmit} className="admin-form">
//         <input
//           name="name"
//           value={formData.name}
//           onChange={handleChange}
//           placeholder="Name"
//           required
//         />
//         <input
//           name="email"
//           type="email"
//           value={formData.email}
//           onChange={handleChange}
//           placeholder="Email"
//           required
//         />
//         {!editMode && (
//           <input
//             name="password"
//             type="password"
//             value={formData.password}
//             onChange={handleChange}
//             placeholder="Password"
//             required
//           />
//         )}

//         <button type="submit" className="submit-btn">
//           {editMode ? 'Update Admin' : 'Create Admin'}
//         </button>

//         {editMode && (
//           <button type="button" className="cancel-btn" onClick={cancelEdit}>
//             Cancel Edit
//           </button>
//         )}
//       </form>

//       <h3>All Admins</h3>
//       <table className="admin-table">
//         <thead>
//           <tr>
//             <th>#</th>
//             <th>Name</th>
//             <th>Email</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {admins.map((admin, index) => (
//             <tr key={admin._id}>
//               <td>{index + 1}</td>
//               <td>{admin.name}</td>
//               <td>{admin.email}</td>
//               <td>
//                 <button onClick={() => handleEdit(admin)}>Edit</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default CreateAdmin;



import React, { useState, useEffect } from 'react';
import { createAdmin, getAdmins, updateAdmin , deleteAdmin} from '../../services/adminService';
import { useAuth } from '../../context/AuthContext';
import './CreateAdmin.css';

const CreateAdmin = () => {
  const { currentUser } = useAuth();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });

  const [admins, setAdmins] = useState([]);
  const [message, setMessage] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [editingAdminId, setEditingAdminId] = useState(null);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const data = await getAdmins();
      setAdmins(data);
    } catch (error) {
      console.error('Error fetching admins:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const updatePayload = {};

    if (formData.name?.trim()) updatePayload.name = formData.name.trim();
    if (formData.email?.trim()) updatePayload.email = formData.email.trim();
    if (formData.password?.trim()) updatePayload.password = formData.password.trim();

    if (editMode) {
      await updateAdmin(editingAdminId, updatePayload);
      setMessage('✅ Admin updated successfully.');
    } else {
      if (!formData.name || !formData.email || !formData.password) {
        setMessage('❌ All fields are required to create a new admin.');
        return;
      }
      await createAdmin({ ...formData, password: formData.password.trim() });
      setMessage('✅ Admin created successfully.');
    }

    setFormData({ name: '', email: '', password: '' });
    setEditMode(false);
    setEditingAdminId(null);
    fetchAdmins();
  } catch (error) {
    console.error(error);
    const errMsg = error.response?.data?.message || 'Server error';
    setMessage(`❌ Operation failed: ${errMsg}`);
  }
};
const handleDelete = async (adminId) => {
  if (!window.confirm('Are you sure you want to delete this admin?')) return;
  try {
    await deleteAdmin(adminId);
    setMessage('✅ Admin deleted successfully.');
    fetchAdmins();
  } catch (error) {
    console.error(error);
    const errMsg = error.response?.data?.message || 'Server error';
    setMessage(`❌ Delete failed: ${errMsg}`);
  }
};


//   const handleEdit = (admin) => {
//     setFormData({
//       name: admin.name,
//       email: admin.email,
//       password: '',
//     });
//     setEditMode(true);
//     setEditingAdminId(admin._id);
//   };
const handleEdit = (admin) => {
  setFormData({
    name: admin.name,
    email: admin.email,
    password: '', // don't fetch password; allow setting new one
  });
  setEditMode(true);
  setEditingAdminId(admin._id);
};

  const cancelEdit = () => {
    setEditMode(false);
    setEditingAdminId(null);
    setFormData({ name: '', email: '', password: '' });
  };

  if (!currentUser?.isSuperAdmin) {
    return <div className="message error">❌ Unauthorized: Only Super Admin can access this page.</div>;
  }

  return (
    <div className="form-container">
      <h2>{editMode ? 'Update Admin' : 'Create New Admin'}</h2>
      {message && <div className={`message ${message.startsWith('✅') ? 'success' : 'error'}`}>{message}</div>}

      <form onSubmit={handleSubmit} className="admin-form">
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Name"
          required
        />
        <input
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          required
        />
        <input
          name="password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          placeholder={editMode ? 'New Password (optional)' : 'Password'}
          required={!editMode}
        />

        <button type="submit" className="submit-btn">
          {editMode ? 'Update Admin' : 'Create Admin'}
        </button>

        {editMode && (
          <button type="button" className="cancel-btn" onClick={cancelEdit}>
            Cancel Edit
          </button>
        )}
      </form>

      <h3>All Admins</h3>
      <table className="admin-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {admins.map((admin, index) => (
            <tr key={admin._id}>
              <td>{index + 1}</td>
              <td>{admin.name}</td>
              <td>{admin.email}</td>
              <td>
                <button onClick={() => handleEdit(admin)}>Edit</button>
                  <button onClick={() => handleDelete(admin._id)} className="delete-btn">Delete</button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CreateAdmin;
